/**
 * Build the authenticated serving URL for a stored photo file path.
 *
 * Daily-log photos live two levels deep (uploads/daily-logs/{date}/{uuid}.ext),
 * so the URL needs both segments — the old last-two-segments build dropped
 * "daily-logs" and 404'd (W1 fix). Single-level paths keep the short form.
 */
export function photoSrc(filePath: string): string {
  const parts = filePath.replace(/\\/g, '/').split('/').filter(Boolean);
  const filename = parts.pop()!;
  const sub = parts.pop();
  const folder = parts.pop();
  // uploads/<folder>/<sub>/<filename> → nested route; uploads/<sub>/<filename> → flat.
  if (folder && folder !== 'uploads') return `/api/photos/${folder}/${sub}/${filename}`;
  return `/api/photos/${sub}/${filename}`;
}
